import { OrderKeys } from '../OrderKeys';
import { SortOptions } from './CommonSortOptions';
import { OptionsDictionary } from './SortOptionDefinitions';
import { createNonDisplayOptionDefinition } from './SortOptionsHelper';

export const scheduleSortOptions: OptionsDictionary = {
  'name': SortOptions.name,
  'scheduleType': createNonDisplayOptionDefinition('scheduleType', OrderKeys.scheduleType),
  'scheduledAction': createNonDisplayOptionDefinition('scheduledAction', OrderKeys.scheduledAction),
  'taskCount': createNonDisplayOptionDefinition('taskCount', OrderKeys.taskCount),
  'parallel': createNonDisplayOptionDefinition('parallel', OrderKeys.parallel),
  'runNextAt': createNonDisplayOptionDefinition('runNextAt', OrderKeys.runNextAt),
};
